import {createContext, useContext} from 'react';
import {brand} from '../brand.js';
const ColorThemeContext = createContext({palette:brand.palette, heatScale:[...brand.heatRamp], overrides:{}});
/** Explicit preview overrides are opt-in. Without them authored props win. */
export function ColorThemeProvider({palette, heatScale, overrides, children}) {
  const parent = useContext(ColorThemeContext);
  return <ColorThemeContext.Provider value={{palette:palette?.length ? palette : parent.palette, heatScale:heatScale?.length ? heatScale : parent.heatScale, overrides:{...parent.overrides,...overrides}}}>{children}</ColorThemeContext.Provider>;
}
export function useColorTheme(component) {
  const theme = useContext(ColorThemeContext);
  const override = theme.overrides[component] || (component?.endsWith('T') ? theme.overrides[component.slice(0,-1)] : undefined);
  return override ? {...theme, ...override, override:true} : theme;
}
